/**
 * VillaMax — Aviso "Bajo pedido" en la página de producto
 *
 * Si ninguna droguería tiene la presentación elegida pero la bodega del
 * proveedor (Coopidrogas) sí, muestra cuándo llega: pedido antes de las
 * 11:00 → desde las 2 p. m.; después → el siguiente día hábil (entre semana,
 * el fin de semana no se recoge en la bodega). Lo decide FarmaSync con el
 * mismo endpoint de las franjas del carrito (modo "supplier").
 *
 * Lee la sede más cercana de location-system.js (localStorage
 * farmalkosto_location); sin sede, pregunta por Marantá, que es la que
 * recoge en la bodega.
 * No usa template literals por compatibilidad con el editor de Shopify.
 */
(function () {
  "use strict";

  var CONTAINER_ID = "vx-supplier-badge";
  var STORAGE_KEY = "farmalkosto_location";
  var API_URL = "https://api.farmasync.com.co/api/shopify/delivery-slots";
  var DEFAULT_STORE = "maranta";
  var cache = {};

  function nearestStore() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      return (parsed && parsed.nearest_store) || DEFAULT_STORE;
    } catch (e) {
      return DEFAULT_STORE;
    }
  }

  function currentSku(container) {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var variants = {};
    try {
      variants = JSON.parse(container.getAttribute("data-variants") || "{}");
    } catch (e) {}
    if (input && variants[input.value]) return variants[input.value];
    return container.getAttribute("data-sku") || "";
  }

  /** "14:00" → "2 p. m." */
  function hour12(hhmm) {
    var h = parseInt(hhmm, 10);
    if (isNaN(h)) return "";
    return (h % 12 || 12) + (h < 12 ? " a. m." : " p. m.");
  }

  function render(container, data) {
    if (!data || !data.success || data.mode !== "supplier" || !data.days || !data.days.length) {
      container.hidden = true;
      return;
    }
    var day = data.days[0];
    var from = hour12((day.slots[0] || "").split(" - ")[0]);
    var when = day.label === "Hoy" || day.label === "Mañana" ? day.label.toLowerCase() : "el " + day.label.toLowerCase();
    // "p. m." ya cierra con punto: no se agrega otro.
    container.textContent = "Bajo pedido · Llega " + when + (from ? " desde las " + from + " " : ". ") +
      "Lo recogemos en la bodega de nuestro proveedor.";
    container.hidden = false;
  }

  function check(container) {
    var sku = currentSku(container);
    if (!sku) return;
    var store = nearestStore();
    var key = store + "|" + sku;
    if (cache[key]) {
      render(container, cache[key]);
      return;
    }
    fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ store: store, items: [{ sku: sku, quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        cache[key] = data;
        render(container, data);
      });
  }

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    check(container);
    document.addEventListener("change", function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(function () { check(container); }, 50);
      }
    });
    window.addEventListener("farmalkosto:location-changed", function () { check(container); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
